import { actionsTheme } from './ActionsList/theme';
import { userThemeTileTheme } from './TilesView/Tile/theme';

export const stylizationTheme = {
  actions: actionsTheme,
  header: {
    title: 'palette.tertiary.95',
  },
  modals: {
    message: 'palette.tertiary.90',
  },
  tiles: {
    tile: userThemeTileTheme,
  },
};
